import {graphConfig,type GraphConfig} from './graph-configuration';
import type {Primitive} from './graph-primitives';

// Authoring metadata only: renderers never branch on a pedagogical intention.
export const graphPresets = {
 build: 'Construire un graphique', fit: 'Ajuster / modéliser', slope: 'Mesurer une pente',
 read: 'Lire une valeur / étalonner', interval: 'Mesurer un intervalle',
 time: 'Déterminer un temps caractéristique', event: 'Repérer un événement',
 titration: 'Exploiter un titrage', explore: 'Explorer une fonction / comparer', custom: 'Personnalisé / avancé',
} as const;
export type GraphPreset = keyof typeof graphPresets;
export const presetTools:Record<GraphPreset,Primitive['kind'][]>={
 build:['point'],fit:['point','line'],slope:['point','onCurve','line','interval'],
 read:['crosshair','point','horizontal','vertical','intersection','projection'],
 interval:['crosshair','onCurve','point','horizontal','intersection','interval','projection'],
 time:['crosshair','point','onCurve','horizontal','vertical','level','tangent','intersection','projection','interval'],
 event:['crosshair','point','horizontal','vertical','intersection','projection'],
 titration:['point','line','horizontal','vertical','intersection','projection'],
 explore:['crosshair','point','onCurve','horizontal','vertical','intersection','projection'],custom:[],
};
export function applyGraphPreset(input:GraphConfig,preset:GraphPreset):GraphConfig {
 if(preset==='custom')return {...input,preset};
 const fit=['fit','slope','read','titration'].includes(preset),data=['build','fit','slope','read','titration'].includes(preset);
 return graphConfig({...input,preset,sourceMode:data?'data':preset==='explore'?'multiple':'function',
  numericPointEntry:data,touchPointEntry:data,allowPointEditing:data,allowPointDeletion:data,allowDataImport:data,
  manualLine:fit,modeling:fit,initialModel:fit?input.initialModel:null,initialLine:fit?input.initialLine:[],
  allowedModels:fit?['proportional','linear']:[],slopeTool:preset==='slope',readValueTool:['read','event','titration','explore','time'].includes(preset),
  showEquation:preset==='fit'||preset==='explore',showR2:preset==='fit',showSlopeCalculation:preset==='slope',
  constructions:{mode:'student',assistance:'none',showValues:false,objects:[],correctionObjects:[],allowedTools:[...presetTools[preset]],methods:preset==='time'?['relative-level','initial-tangent']:[],...(preset==='time'?{reference:input.constructions?.reference??{curve:'theory',startX:input.x.min,start:input.y.min,end:input.y.max,fraction:.63,tolerance:.01}}:{})},
  ...(fit&&input.initialModel&&!['proportional','linear'].includes(input.initialModel)?{initialModel:null}:{}),
 });
}
export function presetFieldVisible(preset:GraphPreset,section:string,source?:GraphConfig['sourceMode']) {
 if(preset==='custom')return true;
 if(section==='function')return ['function','data-function','multiple'].includes(source??'');
 if(section==='data')return ['data','data-function','multiple'].includes(source??'');
 if(section==='slope')return preset==='slope';
 if(section==='fit')return ['fit','slope','read','titration'].includes(preset);
 if(section==='methods')return preset==='time';
 return true;
}
export function presetOptionVisible(preset:GraphPreset,key:keyof GraphConfig,source?:GraphConfig['sourceMode']) {
 if(preset==='custom')return true;
 if(['theoreticalCurve'].includes(key))return presetFieldVisible(preset,'function',source);
 if(['manualLine','modeling','showR2'].includes(key))return presetFieldVisible(preset,'fit',source);
 if(['slopeTool','showSlopeCalculation'].includes(key))return preset==='slope';
 if(key==='readValueTool')return ['read','time','event','titration','explore'].includes(preset);
 if(key==='showEquation')return ['fit','explore'].includes(preset);
 return presetFieldVisible(preset,'data',source);
}
